import { Component, Inject } from "@angular/core";
import { Meeting } from "@common/ADAPT.Common.Model/organisation/meeting";
import { MeetingAgendaItem } from "@common/ADAPT.Common.Model/organisation/meeting-agenda-item";
import { ADAPT_DIALOG_DATA } from "@common/ux/adapt-common-dialog/adapt-common-dialog.globals";
import { BaseDialogComponent } from "@common/ux/adapt-common-dialog/base-dialog.component/base-dialog.component";

@Component({
    selector: "adapt-edit-meeting-agenda-dialog",
    templateUrl: "./edit-meeting-agenda-dialog.component.html",
    standalone: false,
})
export class EditMeetingAgendaDialogComponent extends BaseDialogComponent<Meeting> {
    public readonly dialogName = "EditMeetingAgendaDialog";
    public agendaItems: MeetingAgendaItem[] = [];

    public constructor(
        @Inject(ADAPT_DIALOG_DATA) public meeting: Meeting,
    ) {
        super();
    }
}
